
const imageurl = "http://apievcustomer.de/pp/api/public/images";
//const imageurl = "https://api.evolvejobs.de/vbs/api/public/images";
export default imageurl;